import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import StartScreenLayout from '../../shared/components/start-screen-layout/start-screen-layout';
import { SummarizationFeedbackBanner } from './components/summarization-feedback-banner';
import { selectUserFeedback } from './features/user-feedback/selectors';
import { UserFeedbackType } from './types';

export const FeedbackPage: FunctionComponent = () => {
    const feedback = useSelector(selectUserFeedback);

    const content = (() => {
        if (!feedback) {
            return <SummarizationFeedbackBanner feedback={{ type: UserFeedbackType.SUMMARIZATION }} />;
        }

        switch (feedback.type) {
            case UserFeedbackType.SUMMARIZATION:
                return <SummarizationFeedbackBanner feedback={feedback} />;
        }
    })();

    return <StartScreenLayout>{content}</StartScreenLayout>;
};
